import styled from "@emotion/styled";
import { capitalize } from "es-toolkit";
import { useState, type ReactNode } from "react";

import { FONT_WEIGHT_MEDIUM, Icon, Tooltip } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

const Container = styled.div`
  margin-bottom: 5px;
`;

const Title = styled.div`
  display: grid;
  grid-template-columns: 18px 1fr;
  padding: 5px;
  margin: 0 0 4px;
  border-radius: 5px;

  font-weight: ${FONT_WEIGHT_MEDIUM};
  font-size: ${({ theme }) => theme.fontSizeSmall};
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  svg {
    color: ${({ theme }) => theme.generalTextIconVariant};
  }

  &:hover {
    background: ${({ theme }) => theme.surfaceVariant};
  }
`;

type Props = {
  title: string;
  items: ReactNode[];
};

export const SidebarList = ({ title, items }: Props) => {
  const [expanded, setExpanded] = useState(true);
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <Container>
      <Tooltip title={formatMessage(expanded ? "collapse" : "expand")} placement="top-start">
        <Title onClick={() => setExpanded(!expanded)}>
          <Icon icon={expanded ? "angle-down" : "angle-right"} />
          {capitalize(title)}
        </Title>
      </Tooltip>
      {expanded && items}
    </Container>
  );
};

const formatStrings = {
  expand: {
    en: "Expand",
  },
  collapse: {
    en: "Collapse",
  },
};
